import React from 'react';
import "./App.css"
import Loader from './components/loader';




function App() {
  return (
    <Loader />
    
  )
}

export default App;
